<template>
  <div class="version-mgt-page">
    <div class="global-header-wrap">
      <button
        class="global-button-style"
        @click="$router.push({ name: 'update' })"
      >
        <img src="@/assets/img/cmb_btn_update.png" alt="add" />
        {{ $t("firmware.addFirmware") }}
      </button>
    </div>
    <el-card class="app-table-container" :body-style="{ padding: '20px' }">
      <div class="global-body-wrap">
        <AppTable
          :tableProps="tableProps"
          :tableData="tableData"
          @tableHandle="tableHandle"
        />
      </div>
      <Pagination
        :pageSize="paramsList.limit"
        :total="total"
        @pageNum="pageNum"
      />
    </el-card>
  </div>
</template>

<script>
import AppTable from "@/components/appTable";
import Pagination from "@/components/pagination";
import { mapGetters } from "vuex";

export default {
  name: "Version",
  components: {
    AppTable,
    Pagination
  },
  computed: {
    tableProps() {
      let tableProps = [
        {
          prop: "model",
          label: this.$t("firmware.model")
        },
        {
          prop: "brand",
          label: this.$t("firmware.brand")
        },
        {
          prop: "buildNumber",
          label: this.$t("firmware.versions")
        },
        {
          prop: "md5",
          label: "MD5"
        },
        {
          prop: "updatedAt",
          label: this.$t("firmware.time")
        },
        {
          prop: "handle",
          label: this.$t("commonMsg.handle"),
          width: 120,
          btn: [this.$t("commonMsg.edit"), this.$t("commonMsg.del")]
        }
      ];
      return tableProps;
    }
  },
  data() {
    return {
      tableData: [],
      total: 0,
      paramsList: { limit: 20, offset: 0 }
    };
  },
  methods: {
    getFirmware() {
      this.$http
        .getFirmware(this.paramsList)
        .then(res => {
          this.total = res.data.count;
          this.tableData = res.data.rows;
        })
        .catch(() => {});
    },

    delFirmware(id) {
      this.$http
        .delFirmware(id)
        .then(res => {
          this.getFirmware();
          this.elMsg(this.$t("alertMsg.delSuccess"), "success");
        })
        .catch(() => {});
    },

    tableHandle(obj) {
      if (obj.type === this.$t("commonMsg.edit"))
        this.$router.push({
          name: "update",
          query: { editId: obj.data.row._id }
        });
      if (obj.type === this.$t("commonMsg.del"))
        this.delFirmware(obj.data.row._id);
    },

    pageNum(val) {
      this.paramsList.offset = (val - 1) * this.paramsList.limit;
      this.getFirmware();
    }
  },
  mounted() {
    this.getFirmware();
  }
};
</script>

<style lang="scss" scoped>
.version-mgt-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .global-header-wrap {
    justify-content: flex-end;
  }
  .app-mgt-page {
    flex: 1;
  }
}
</style>
